import produce from 'immer'
import { assign, set } from 'lodash'

import { METADATA_TYPES } from '../../../common/constants'
import { buildTreeHierarchy } from '../../../common/helpers'

import {
  ADD_CHALLENGE,
  DELETE_CHALLENGE,
  FETCH_CHALLENGES,
  RENAME_CHALLENGE,
  RESET_CHALLENGE_TREE,
  SAVE_CHALLENGES,
  SET_DATA_FOR_RENAMING_CHALLENGE,
} from '../action-types'
import { CHALLENGES_INITIAL_STATE } from '../initial-states'

const challengesReducer = (state = CHALLENGES_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CHALLENGES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          initialData: [],
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_CHALLENGES.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } = action.payload.data.challenges
        const treeData = buildTreeHierarchy(results, METADATA_TYPES.CHALLENGES)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          latestEvent,
        })
      })

    case FETCH_CHALLENGES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
          initialData: [],
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_CHALLENGES.CLEANUP:
      return { ...CHALLENGES_INITIAL_STATE }

    case SAVE_CHALLENGES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          latestEvent: undefined,
        }),
      )

    case SAVE_CHALLENGES.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } = action.payload.data.saveChallenges

        const treeData = buildTreeHierarchy(results, METADATA_TYPES.CHALLENGES)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          isDirty: false,
          dataForRenaming: undefined,
          latestEvent,
        })
      })

    case SAVE_CHALLENGES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
          latestEvent: undefined,
        }),
      )

    case DELETE_CHALLENGE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
        }),
      )

    case DELETE_CHALLENGE.COMPLETE:
      return produce(state, nextState => {
        const { results } = action.payload.data.deleteChallenge

        const treeData = buildTreeHierarchy(results, METADATA_TYPES.CHALLENGES)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          isDirty: false,
          dataForRenaming: undefined,
        })
      })

    case DELETE_CHALLENGE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
        }),
      )

    case ADD_CHALLENGE:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: [...nextState.data, action.payload],
          isDirty: true,
          dataForRenaming: { id: action.payload.id },
        }),
      )

    case RENAME_CHALLENGE:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: set(
            nextState.data,
            `${action.payload.path}.name`,
            action.payload.name,
          ),
          isDirty: true,
        }),
      )

    case SET_DATA_FOR_RENAMING_CHALLENGE:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          dataForRenaming: action.payload,
        }),
      )

    case RESET_CHALLENGE_TREE:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: nextState.initialData,
          isDirty: false,
          dataForRenaming: undefined,
        }),
      )

    default:
      return state
  }
}

export default challengesReducer
